// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  background-color: white;
  padding: 20px;
  height: 100%;
}

:host.text-sm::ng-deep h1 {
  font-size: 24px;
}
:host.text-sm::ng-deep h2 {
  font-size: 18px;
}

:host.text-md::ng-deep p {
  font-size: 1rem;
}

:host.text-lg::ng-deep p {
  font-size: 1.1rem;
}

:host.text-xl::ng-deep p {
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/storyblok/components/storyblok-text/storyblok-text.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,aAAA;EACA,YAAA;AACF;;AAIE;EACE,eAAA;AADJ;AAIE;EACE,eAAA;AAFJ;;AAOE;EACE,eAAA;AAJJ;;AASE;EACE,iBAAA;AANJ;;AAWE;EACE,iBAAA;AARJ","sourcesContent":[".background {\n  background-color: white;\n  padding: 20px;\n  height: 100%;\n}\n\n:host.text-sm::ng-deep {\n\n  h1 {\n    font-size: 24px;\n  }\n\n  h2 {\n    font-size: 18px;\n  }\n}\n\n:host.text-md::ng-deep {\n  p {\n    font-size: 1rem;\n  }\n}\n\n:host.text-lg::ng-deep {\n  p {\n    font-size: 1.1rem;\n  }\n}\n\n:host.text-xl::ng-deep {\n  p {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
